export default __webpack_public_path__ + "static/media/LogoReportLTD.90e190af.png";